<template>
    <div>
        <BreadCrumb v-if="!data" :data="breadCrumb" /> 
        <b-card class="formGroup">
            <FormComponent :loading="loading" ref="ServiceForm" :forms="ServiceForm" />
             <template slot="footer">
                <b-button variant="primary" @click="saveForm">{{$t('general.save')}}</b-button>
            </template>
        </b-card>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import moment from 'moment'
    import FormComponent from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'

    let breadCrumb = [
        { label: i18n.t('pages.dealer.name'), url: "/Dealer" },
        { label: i18n.t('pages.dealer.addService'), url: "/Dealer/ServicesForm/Add" },
    ]
    export default {
        name: 'AddService',
        data: function(){
            return{
                breadCrumb,
                ServiceForm: Forms.ServiceForm
            }
        },
        created: function(){
            if(this.data && this.data.customerId){
                 this.$store.dispatch('getCustomerDetail', {id: this.data.customerId})
                 this.$store.dispatch('customeraddresses_get', {parent_id: this.data.customerId})
            }
        },
        components:{
            BreadCrumb, FormComponent
        },
        props:{
            data: Object
        },
        computed: {
            loading(){
                return this.$store.getters.getDealerLoading || this.$store.getters.getCustomerLoading || 
                this.$store.getters.getUserLoading 
            }
        },
       
       
        methods:{
            saveForm: async function(){
                this.$refs.ServiceForm.$refs.Form.validate().then( async success => {
                    if(success){
                        let data = prepareRequestData(this.ServiceForm, this.$refs.ServiceForm.formData)

                        await this.$store.dispatch('serviceForm_add', data)
                        if(this.$store.getters.getServiceForm.status == "Success"){
                            this.$router.push('/Dealer/ServiceForms')
                            return true
                        }else{
                            return false
                        }
                    
                    }else {
                        return false
                    }
                })  
            }
        }
    }
</script>
<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Dealer/AddService.vue